export default __webpack_public_path__ + "static/media/image_1.8953b807.jpg";